module.exports = __webpack_public_path__ + "img/frame (160).47bdc28e.jpg";